import Bugsnag, { BreadcrumbType } from "@bugsnag/js";

const LeaveBreadcrumb = (
  message: string,
  metadata: Record<string, string | number> = {},
  type: BreadcrumbType | undefined = undefined,
) => {
  const { href } = window.location;
  Bugsnag.leaveBreadcrumb(
    message,
    {
      ...metadata,
      href,
    },
    type,
  );
};

export default LeaveBreadcrumb;
